export const TEST_DETAILS_API_ROUTES = {
   DETAILS: 'testPage',
   SIMILAR_TEST: 'similarTest',
   TEST_DETAILS: 'testDetails',
   TEST_LIST: 'testSearchDetailsUsingFilter',
   SEARCH_FILTERS: 'search/filters',
   TEST_SERIES_LIST: 'testSeries/testSeriesSearchUsingFilter',
   TEST_SERIES_LIST_ALL: 'testSeries/testSeriesSearchUsingFilterAll',
   TEST_SERIES_FILTERS: 'testSeries/filters',
   EXAM_DETAILS: 'examDetails',
   TEST: 'test',
   PREVIOUS_OPEN_TEST: 'previousOpenTest',
   END_PREVIOUS_OPEN_TEST: 'endPreviousTestIfOpen',
   DIFFICULTY_LEVEL: 'testPage/difficultylevel',
   TEST_SERIES_BY_CLASS: 'testPage/testSeriesList',
   CHAPTER_LIST: 'testPage/chapterlist',
   TOPIC_LIST: 'testPage/topiclist',
   EXAM_QUESTION: 'examQuestion',
   IABHYAS_TESTS:'/user/IabhyasSearchToggle',
}